// src/components/Footer.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// Import Social Icons
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaDiscord, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="text-center py-10 px-5 bg-[#1a365d] text-white mt-12 border-t-4 border-indigo-600">
      
      {/* Navigation Links - Harmonized with Header */}
      <nav className="mb-8 space-x-6 text-sm flex flex-wrap justify-center gap-y-4">
        <Link to="/" className="hover:text-blue-300 transition">{t('home')}</Link>
        <Link to="/about" className="hover:text-blue-300 transition">{t('about')}</Link>
        <Link to="/pricing" className="hover:text-blue-300 transition">{t('pricing')}</Link>
        <Link to="/lexicon" className="hover:text-blue-300 transition">{t('argot', 'Argot')}</Link>
        <Link to="/leaderlab" className="hover:text-blue-300 transition">Leader Lab</Link>
        
        {/* Dashboards & Strategic Links */}
        <span className="text-blue-500">|</span>
        <Link to="/teacher-dashboard" className="hover:text-blue-300 transition">{t('teacher')}</Link>
        <Link to="/partner-dashboard" className="hover:text-blue-300 transition">Partners</Link>
        <Link to="/investment" className="hover:text-blue-300 transition">Community Fund</Link>
        <Link to="/community-investment" className="hover:text-blue-400">Public Investment</Link>
        <Link to="/borealis" className="text-cyan-400 hover:text-cyan-200 font-bold transition">Project Borealis</Link>
        <span className="text-blue-500">|</span>
        
        <Link to="/contact" className="hover:text-blue-300 transition">{t('contact')}</Link>
      </nav>

      {/* --- SOCIAL MEDIA SECTION --- */}
      <div className="flex justify-center items-center gap-6 mb-8">
        <a href="https://www.facebook.com/people/Aulice-Pro-Mastery/61585945110605/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 hover:scale-110 transition-all duration-300">
          <FaFacebook size={24} />
        </a>

        <a href="https://x.com/AulicePro" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white hover:scale-110 transition-all duration-300">
          <FaTwitter size={24} />
        </a>

        <a href="https://www.instagram.com/aulice_pro/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-500 hover:scale-110 transition-all duration-300">
          <FaInstagram size={24} />
        </a>

        <a href="https://www.linkedin.com/company/aulice-pro-mastery" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 hover:scale-110 transition-all duration-300">
          <FaLinkedin size={24} />
        </a>

        <a href="https://discord.gg/BDatnMHH8j" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-400 hover:scale-110 transition-all duration-300">
          <FaDiscord size={24} />
        </a>
        
        {/* Added Borealis Channel Link */}
        <a href="https://www.youtube.com/@Borealis-u4p" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-600 hover:scale-110 transition-all duration-300" title="Project Borealis">
          <FaYoutube size={24} />
        </a>
      </div>

      {/* Copyright */}
      <div className="opacity-70 text-xs border-t border-gray-700 pt-6 max-w-2xl mx-auto">
        <p>© 2025 Aulice Academy. Reality is programmable. Smart people are its architects.</p>
        <p className="mt-2 text-gray-500">Pro Mastery Ecosystem v2.1</p>
      </div>
    </footer>
  );
};

export default Footer;